import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImperativeHandle, useLayoutEffect, useMemo, useRef, useState } from 'react';
import cn from 'classnames';
import { FullPageModal, ScrollToTopButton, useDevice } from 'seagull';
import ErrorBoundaryPage from '~/components/ErrorBoundaryPage';
import styles from '../AgreementStudioPage.module.scss';
export function AgreementStudioShell(props) {
    const { onClose, rightPane, doScrollToTopRef, contentKey, children } = props;
    const { isMobileDevice } = useDevice();
    const [scrollContainer, setScrollContainer] = useState(null);
    const savedScrollTopRef = useRef(null);
    useImperativeHandle(doScrollToTopRef, ()=>{
        return ()=>scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollTo({
                left: 0,
                top: 0,
                behavior: 'smooth'
            });
    });
    // useMemo runs during render — captures scrollTop before the new contentKey's children commit.
    useMemo(()=>{
        if (scrollContainer != null) savedScrollTopRef.current = scrollContainer.scrollTop;
    }, [
        contentKey
    ]);
    useLayoutEffect(()=>{
        const saved = savedScrollTopRef.current;
        if (saved == null || scrollContainer == null) return;
        savedScrollTopRef.current = null;
        const max = scrollContainer.scrollHeight - scrollContainer.clientHeight;
        scrollContainer.scrollTop = Math.max(0, Math.min(saved, max));
    }, [
        contentKey,
        scrollContainer
    ]);
    return /*#__PURE__*/ _jsx(FullPageModal, {
        testId: "full-page-agreement-studio",
        onClose: onClose,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn(styles.mainContainer, {
                [styles.mobile]: isMobileDevice
            }),
            "data-testid": "agreement-studio",
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.agreementStudio,
                ref: setScrollContainer,
                "data-testid": "agreement-studio-body",
                children: /*#__PURE__*/ _jsxs(ErrorBoundaryPage, {
                    bounded: true,
                    children: [
                        !isMobileDevice && /*#__PURE__*/ _jsx(ScrollToTopButton, {
                            bi: {
                                name: 'agreement_studio_scroll_to_top'
                            },
                            testId: "scroll-up-arrow",
                            scrollContainer: scrollContainer
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: cn(styles.studioLayout, {
                                [styles.withPane]: rightPane != null,
                                [styles.isOpen]: (rightPane === null || rightPane === void 0 ? void 0 : rightPane.isOpen) === true
                            }),
                            children: [
                                children,
                                rightPane === null || rightPane === void 0 ? void 0 : rightPane.element
                            ]
                        })
                    ]
                })
            })
        })
    });
}
